module.exports = __webpack_public_path__ + "img/DSC_2266_referencia.c967d63a.jpg";